import React, { useState } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Tooltip,
  Button,
  Checkbox,
} from '@material-ui/core';
import EnhancedTableHead from '../../CommonComponents/TableComponents/EnhancedTableHead';
import {
  getComparator,
  stableSort,
} from '../../CommonComponents/TableComponents/TableUtils';
import {
  assignFlexReceiveDate,
  mapDeletedSiteData,
  mapEstimateDeletedSiteData,
} from '../../redux/actions/sites';
import FallbackCard from '../../CommonComponents/FallbackCard';

const headCells = [
  {
    id: 'siteId',
    numeric: false,
    disablePadding: false,
    label: 'Site Id',
  },
  {
    id: 'location',
    numeric: true,
    disablePadding: false,
    label: 'Location',
  },
  {
    id: 'state',
    numeric: true,
    disablePadding: false,
    label: 'State',
  },
  {
    id: 'city',
    numeric: true,
    disablePadding: false,
    label: 'City',
  },
  {
    id: 'supplier',
    numeric: true,
    disablePadding: false,
    label: 'Supplier',
  },
  {
    id: 'startDate',
    numeric: true,
    disablePadding: false,
    label: 'Start Date',
  },
  {
    id: 'endDate',
    numeric: true,
    disablePadding: false,
    label: 'End Date',
  },
  {
    id: 'map',
    numeric: true,
    disablePadding: false,
    label: 'Map With New Row',
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  title: {
    marginRight: 30,
    marginTop: 12,
    float: 'left',
  },
  assignButtonWidth: {
    marginRight: 20,
  },
  searchBar: {
    float: 'right',
    width: '100%',
  },
}));

const DeletedSiteTable = ({
  allSites, currentPageCount, mapSiteData, mapDeletedSites, estimateId,
}) => {
  const classes = useStyles();
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('SiteId');
  const [page] = useState(0);
  const [selected, setSelected] = useState([]);
  const [checkBoxState, setCheckbox] = React.useState(true);

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    setSelected(newSelected);
  };

  const handleSelectAllClick = (event) => {
    if (checkBoxState) {
      if (event.target.checked) {
        const newSelecteds = allSites
          .map((obj) => obj.id);
        setSelected(newSelecteds);
        setCheckbox(false);
      }
    } else {
      setCheckbox(true);
      setSelected([]);
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };
  const isSelected = (name) => selected.indexOf(name) !== -1;
  const userType = JSON.parse(localStorage.getItem('user'));
  return (
    <div className={classes.root}>
      {allSites.length > 0 ? (
        <div>
          <div className="row">
            <div className="col-3">
              <Button
                color="primary"
                size="large"
                variant="contained"
                disabled={!selected.length}
                onClick={() => {
                  mapSiteData(selected);
                  setSelected([])
                }}
              >
                Map All Selected Sites
              </Button>
            </div>
            <div className="col-3">
              <Button
                color="primary"
                size="large"
                variant="contained"
                disabled={selected.length}
                onClick={() => mapDeletedSites(estimateId)}
              >
                Map All Deleted Sites
              </Button>
            </div>
          </div>
          <br />
          <br />
          <Paper className={classes.paper}>
            <TableContainer>
              <Table
                className={classes.table}
                aria-labelledby="tableTitle"
                size="medium"
                aria-label="enhanced table"
              >
                <EnhancedTableHead
                  headCells={headCells}
                  classes={classes}
                  numSelected={selected.length}
                  order={order}
                  orderBy={orderBy}
                  onSelectAllClick={userType && (userType.userType === 'admin' || userType.userType === 'manager') ? handleSelectAllClick : handleSelectAllClick}
                  onRequestSort={handleRequestSort}
                  rowCount={allSites.length}
                  checkbox
                />
                <TableBody>
                  {stableSort(allSites, getComparator(order, orderBy))
                    .slice(
                      page * currentPageCount,
                      page * currentPageCount + currentPageCount,
                    )
                    .map((row, index) => {
                      const isItemSelected = isSelected(row.id);
                      const labelId = `enhanced-table-checkbox-${index}`;
                      return (
                        <TableRow hover tabIndex={-1} key={row.id}>
                          <TableCell padding="checkbox">
                            {userType && (userType.userType === 'admin' || userType.userType === 'manager')
                              ? (
                                <Checkbox
                                  color="primary"
                                  checked={isItemSelected}
                                  inputProps={{ 'aria-labelledby': labelId }}
                                  onChange={(event) => handleClick(event, row.id)}
                                />
                              )
                              : (
                                <Checkbox
                                  color="primary"
                                  checked={isItemSelected}
                                  inputProps={{ 'aria-labelledby': labelId }}
                                  onChange={(event) => handleClick(event, row.id)}
                                />
                              )}
                          </TableCell>
                          <TableCell component="th" id={labelId} scope="row">
                            {row.siteId}
                          </TableCell>
                          <TableCell>{row.locationName}</TableCell>
                          <TableCell>{row.stateName}</TableCell>
                          <TableCell>{row.cityName}</TableCell>
                          <TableCell>{row.supplierName}</TableCell>
                          <TableCell>
                            {moment(
                              row.newStartDate
                                ? row.newStartDate
                                : row.startDate,
                            ).format('DD MMM YYYY')}
                          </TableCell>
                          <TableCell>
                            {moment(row.newEndDate ? row.newEndDate : row.endDate).format('DD MMM YYYY')}
                          </TableCell>
                          <TableCell>
                            <Tooltip
                              title="Map deleted site data with new row"
                              placement="top"
                              arrow
                            >
                              <Button
                                color="primary"
                                size="small"
                                aria-label="map-site-data"
                                aria-haspopup="menu"
                                onClick={() => {
                                  mapSiteData([row.id]);
                                  setSelected([])
                                }}
                              >
                                Map
                              </Button>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </div>
      ) : (
        <FallbackCard text="No data found" />
      )}
    </div>
  );
};

const mapState = (state) => ({
  allSites: state.sites.allSites,
  currentPageCount: state.sites.currentPageCount,
});

const mapActions = {
  assignFlexDate: assignFlexReceiveDate,
  mapSiteData: mapDeletedSiteData,
  mapDeletedSites: mapEstimateDeletedSiteData,
};

export default connect(mapState, mapActions)(DeletedSiteTable);
